/* Info Component for Home */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info1 = () => {
  return (
    <div className='mb-5'>
    <Row className='mb-3'>
    <Col className={`px-3 pt-1 ${styles.SubTitle6 }`} md={{span: 10, offset: 1 }}>
    <h5 className={`text-center pb-2 ${styles.Red }`} >QUICK FLOW</h5>
    <hr className={`mt-0`}/>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> The short videos contained in the <span className={`${styles.Red}`}>Tutorials</span> contain 
    the necessary instructions for all the Platform's features.
    </p> 
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> The features themselves include <span className={`${styles.Red}`}>INFO</span> buttons,
    the main page giving an overview and all subsections giving short instructions 
      to guide you through the Platform workflow.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Start in the <span className={`${styles.Red}`}>Scenes Workspace</span> by 
    creating Scenes for every Heading in the Script. 
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Create Scene Breakdown 
    and Character pages, creating the Project's Characters and Locations as you go.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Creative features</span>, including Moodboards and
      Scene Workshops to collaborate and design the Production Shoot.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Register the Admin and Crew Users in <span className={`${styles.Red}`}>Manage Users</span> and
      add the Crew details to their Position in the Crew Info section.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Register the <span className={`${styles.Red}`}>Cast</span> members then add their details to 
      their Character's page.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Add the each Locations's <span className={`${styles.Red}`}>Filming Details</span> to
      its Location page.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Create Shoot Day <span className={`${styles.Red}`}>Stripboards</span> in 
      the Schedule section which autofills Scene details.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Create <span className={`${styles.Red}`}>Callsheets</span> in 
      the Callsheets section which autofills details from the Schedule section.
    </p>
    <hr />
    </Col>
    </Row>
    </div>
  )
}

export default Info1